// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".messages[data-v-bc5ae4a2]{position:initial}\n", ""]);
// Exports
module.exports = exports;
